import { FC } from 'react'
import { CmsOption } from '../index'
import { useBlogRichText } from '@/components/Blog/hooks/useBlogRichText'
import styles from './styles.module.scss'
import { AnswerResource } from './AnswerResource'

export interface AnswerProps {
  data: CmsOption
}

export const Answer: FC<AnswerProps> = ({ data }) => {
  return (
    <div className={styles.answer}>
      <div className={styles.richTextContent}>
        <h5 className={styles.title}>{data.fields.title}</h5>
        {useBlogRichText(data.fields.richText)}
      </div>
      <div className={styles.resources}>
        {data.fields.resources?.map(resource => (
          <AnswerResource key={resource.sys.id} {...resource} />
        ))}
      </div>
    </div>
  )
}
